import axios from './_contaAxios'

export const getCuentasContablesSelect = ({ busqueda }) =>
  axios.get('/cuentas-contables', {
    params: {
      tipoConsulta: 'select2',
      analitica: true,
      busqueda
    }
  })

export const getCuentasContables_PorFiltros = ({ prefijo, moneda }) =>
  axios.get('/cuentas-contables', {
    params: {
      tipoConsulta: 'prefijo-moneda',
      prefijo: prefijo,
      moneda: moneda
    }
  })
